import * as Sentry from '@sentry/react';
import { Integrations as TracingIntegrations } from '@sentry/tracing';
import { Dedupe as DedupeIntegration } from '@sentry/integrations';
import { matchPath } from 'react-router-dom';
import initData from 'init-data';
import { getHistory } from 'tradera-utils/history';
import { AxiosIntegration } from 'tradera-utils/sentry/axios-integration';
import { ALL_ROUTES } from 'tradera-constants/routes';
import {
    SHARED_CONFIG,
    beforeSend,
    getEnvironmentFromOrigin
} from 'tradera-utils/sentry/config';

window.Sentry = Sentry;

const DEBUG_SENTRY = window.location.search.includes('debug-sentry');

try {
    // https://docs.sentry.io/error-reporting/configuration/?platform=javascript
    Sentry.init({
        dsn: 'https://aded37c82da24c40b403e8790998c27d@sentry.io/143263',
        environment: getEnvironmentFromOrigin(window.location.origin),
        release: window.releaseVersion,
        // Sample rate is controlled by selective loading through the feature toggle "sentry"
        sampleRate: 1.0,
        tracesSampleRate: DEBUG_SENTRY ? 1 : 0.01,
        integrations: [
            new TracingIntegrations.BrowserTracing({
                routingInstrumentation: Sentry.reactRouterV5Instrumentation(
                    getHistory(),
                    ALL_ROUTES,
                    matchPath
                )
            }),
            new DedupeIntegration(),
            new AxiosIntegration()
        ],
        beforeSend: (event, hint) =>
            beforeSend({ event, hint, isServer: false }),
        beforeBreadcrumb(breadcrumb, hint) {
            if (breadcrumb.category === 'ui.click') {
                const { target } = hint.event;
                if (target && target.ariaLabel) {
                    breadcrumb.message = target.ariaLabel;
                }
            }
            return breadcrumb;
        },
        ...SHARED_CONFIG
    });

    if (initData) {
        if (initData.isLoggedIn) {
            Sentry.setUser({
                id: initData.memberId
            });
        }
        Sentry.setTag('loggedIn', initData.isLoggedIn);
        Sentry.setTag('isHybridAppContext', initData.isHybridAppContext);
        Sentry.setTag('isNativeAppContext', initData.isNativeAppContext);
    }
} catch (e) {
    console.error(e);
}
